'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const LargeContactIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="LargeContactIcon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 90 90"
        id="User-Multiple-Accounts--Streamline-Core"
        height="90"
        width="90"
      >
        <desc>User Multiple Accounts Streamline Icon: https://streamlinehq.com</desc>
        <g id="user-multiple-accounts">
          <path
            id="Union"
            fill="#5073c3"
            d="M28.92857142857143 3.2142857142857144C23.60295 3.2142857142857144 19.285714285714285 7.531521428571429 19.285714285714285 12.857142857142858v48.214285714285715c0 5.325428571428572 4.317235714285714 9.642857142857142 9.642857142857142 9.642857142857142H77.14285714285714c5.325428571428572 0 9.642857142857142 -4.317428571428572 9.642857142857142 -9.642857142857142V12.857142857142858c0 -5.325621428571429 -4.317428571428572 -9.642857142857142 -9.642857142857142 -9.642857142857142H28.92857142857143Z"
            strokeWidth="6.4286"
          ></path>
          <path
            id="Union_2"
            fill="#d8dce5"
            d="M12.857142857142858 19.285714285714285C7.531521428571429 19.285714285714285 3.2142857142857144 23.60295 3.2142857142857144 28.92857142857143V77.14285714285714c0 5.325428571428572 4.317235714285714 9.642857142857142 9.642857142857142 9.642857142857142h48.214285714285715c5.325428571428572 0 9.642857142857142 -4.317428571428572 9.642857142857142 -9.642857142857142V28.92857142857143c0 -5.325621428571429 -4.317428571428572 -9.642857142857142 -9.642857142857142 -9.642857142857142H12.857142857142858Z"
            strokeWidth="6.4286"
          ></path>
          <path
            id="Union_3"
            fill="#5073c3"
            fillRule="evenodd"
            d="M36.964285714285715 54.642857142857146c6.213214285714286 0 11.25 -5.036785714285714 11.25 -11.25S43.1775 32.142857142857146 36.964285714285715 32.142857142857146 25.714285714285715 37.17964285714286 25.714285714285715 43.392857142857146 30.75107142857143 54.642857142857146 36.964285714285715 54.642857142857146ZM14.464285714285715 83.57142857142857c0 -12.426428571428572 10.073571428571428 -22.5 22.5 -22.5s22.5 10.073571428571428 22.5 22.5v3.2142857142857144h-45V83.57142857142857Z"
            clipRule="evenodd"
            strokeWidth="6.4286"
          ></path>
        </g>
      </svg>
    </SvgIcon>
  )
}

LargeContactIcon.propTypes = {
  sx: PropTypes.object
}
